import React from "react";

function Header({ image }) {
  return <img className="m-auto max-w-md lg:m-0" src={image} />;
}

export default Header;
